import api, { baseApiService } from "shared/api";
import useSWRImmutable from "swr/immutable";
import { useCompanySwitchStore } from "modules/CompanySwitch/store/useCompanySwitchStore";

export function useRequestDependencies(
  formType,
  id,
  { triggerRequest = true } = {}
) {
  const selectedCompany = useCompanySwitchStore(
    (state) => state.selectedCompany ?? ""
  );

  return useSWRImmutable(
    id !== undefined && triggerRequest
      ? [
          baseApiService.ENDPOINTS.request.shared.dependencies,
          formType,
          id,
          selectedCompany,
        ]
      : null,
    ([url, formType, id]) =>
      api
        .post(url, {
          form_type: formType,
          application_id: id,
          company_code: selectedCompany.code,
        })
        .then((res) => res.data.data),
    {
      revalidateOnMount: true,
    }
  );
}
